<template>
    <div class="pickup-return-box">
        <div class="title" v-if="pickupDeliveryOption !== 'no_delivery'">
            <font-awesome-icon icon="far fa-truck" />
            <div class="txt">
                <b>{{$t('pds.delivery_cost.headline')}}</b>
                <span v-if="pickupDeliveryOption !== 'no_delivery' && returnDeliveryOption !== 'no_delivery' && returnDisplayLocation">{{$t('pds.delivery_cost.sub.headline')}}</span>
                <span v-if="pickupDeliveryOption !== 'no_delivery' && returnDeliveryOption === 'no_delivery' || !returnDisplayLocation">{{$t('pds.delivery_cost.sub.headline_pickup_only')}}</span>
            </div>
        </div>
        <div class="calculator-box">
            <vue-google-autocomplete
                id="map"
                ref="toAddress"
                classname="form-control"
                :placeholder="$t('pds.delivery_cost.enter_address')"
                v-on:placechanged="getAddressData"
                :country="this.$root.whitelabel.setting('wlCountry')"
                types="geocode"
                @blur="onBlur(address)"
            >
            </vue-google-autocomplete>
            <button type="button" class="btn btn-secondary btn-block" @click="getCosts" v-if="!isLoading && !isSubmitting">{{$t('pds.delivery_cost.calculate')}}</button>
            <button type="button" class="btn btn-secondary btn-block" v-if="isLoading || isSubmitting">{{$t('pds.delivery_cost.loading')}}</button>
            <div class="alert alert-danger" v-if="response && !response.error && this.response.costs_unformatted <= 0">
                <span>{{$t('pds.delivery_cost.result.zero_delivery_cost')}}</span>
            </div>
        </div>

        <div class="pickup-location" v-bind:class = "(pickupDeliveryOption == 'no_delivery') ? 'no-calculator' : ''" v-if="pickupDisplayLocation && !this.sameAddress">
            <font-awesome-icon icon="far fa-location" />
            <div class="txt">
                <div class="left">
                    <b>{{$t('pds.delivery_cost.pickup.location')}} </b>
                    <span>{{ pickupDisplayLocation }}</span>
                </div>
                <div class="right" v-if="(this.selectedCalculationOption === 'pick-up' || this.selectedCalculationOption === 'both') && response && !response.error && this.pickupLocation.costs_unformatted != 0">
                    <span>{{$t('pds.delivery_cost.result.costs')}} {{ pickupLocationPrice }}</span>
                    <span>{{$t('pds.delivery_cost.result.distance')}} {{ pickupLocationDistance }}</span>
                </div>
            </div>
        </div>

        <div class="return-location" v-if="this.returnDisplayLocation && !this.sameAddress && this.returnDeliveryOption !== 'no_delivery'">
            <font-awesome-icon icon="far fa-arrow-to-right" />
            <div class="txt">
                <div class="left">
                    <b>{{$t('pds.delivery_cost.return.location')}}</b>
                    <span>{{ returnDisplayLocation }}</span>
                </div>
                <div class="right" v-if="(this.selectedCalculationOption === 'return' || this.selectedCalculationOption === 'both') && response && !response.error && this.returnLocation.costs_unformatted != 0">
                    <span>{{$t('pds.delivery_cost.result.costs')}} {{ returnLocationPrice }}</span>
                    <span>{{$t('pds.delivery_cost.result.distance')}} {{ returnLocationDistance }}</span>
                </div>
            </div>
        </div>

        <div class="pickup-return-location" v-if="this.pickupDisplayLocation && this.returnDisplayLocation && this.sameAddress">
            <font-awesome-icon icon="far fa-location" />
            <div class="txt">
                <div class="left">
                    <b>{{$t('pds.delivery_cost.pickup.return.location')}}</b>
                    <span>{{ pickupDisplayLocation }}</span>
                </div>
                <div class="right" v-if="this.selectedCalculationOption === 'both' && response && !response.error && this.pickupLocation.costs_unformatted != 0">
                    <span>{{$t('pds.delivery_cost.result.costs')}} {{ pickupLocationPrice }}</span>
                    <span>{{$t('pds.delivery_cost.result.distance')}} {{ pickupLocationDistance }}</span>
                </div>
            </div>
        </div>
        <div class="title">
            <div class="txt">
                <strong>{{ $t('pds.delivery_cost.footnote.head') }}</strong>
                <span>{{ $t('pds.delivery_cost.footnote.optional_note') }}</span>
                <span>{{ $t('pds.delivery_cost.footnote.choose_later') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {BFormRadio} from "bootstrap-vue";

export default {
    name: 'PickupAndReturnBox',
    components: {
        VueGoogleAutocomplete,
        BFormRadio
    },
    data() {
        return {
            address: '',
            error: '',
            response: null,
            pickupLocation: null,
            returnLocation: null,
            isSubmitting: false,
            selectedCalculationOption: 'both',
        }
    },
    props: {
        entry: null,
        isLoading: true
    },
    methods: {
        onBlur(addressData) {

            if (this.googleAddress == undefined) {
                return
            }
            if (this.$refs.toAddress.$refs.autocomplete.value ==='') {
                this.address = ''
                return
            }

            if (this.$refs.toAddress.$refs.autocomplete.value !== this.googleAddress) {
                this.$refs.toAddress.$refs.autocomplete.value = this.googleAddress
            }
        },
        getAddressData(addressData, placeResultData, id) {
            this.googleAddress = this.$refs.toAddress.$refs.autocomplete.value;
            this.address = addressData;
        },
        getCosts() {
            this.isSubmitting = true
            if(this.address === '') {
                this.error = this.$t('pds.delivery_cost.address_error')
                this.isSubmitting = false
                return
            } else {
                this.$axios.post('api/v1/vehicle/delivery_cost', {
                    address: `${this.formattedAddress}`,
                    vehicle_uuid: this.entry.vehicle_uuid,
                    delivery_methods: this.getLocationFromApi
                }).then((response) => {
                    if(response.error === true) {
                        this.error = this.$t('pds.delivery_cost.error')
                    } else {
                        this.response = response.data;
                        for (let key in this.response) {
                            if (key === 'pick-up') {
                                this.pickupLocation = this.response[key];
                            }
                            if (key === 'return') {
                                this.returnLocation = this.response[key];
                            }
                        }
                    }
                    this.isSubmitting = false
                }).catch(e => {
                    this.error = this.$t('pds.delivery_cost.error')
                    this.isSubmitting = false
                })
            }
        },
        getPrice(locationResponse) {
            const price = this.$root.whitelabel.setting('show_price_without_taxes') ? locationResponse.costs_unformatted_net : locationResponse.costs_unformatted
            const vatText = this.$root.whitelabel.setting('show_price_without_taxes') ? this.$t('general.net') : ''
            return `${this.$root.whitelabel.getFormatetPrice(price)} ${vatText}`
        },
        getDisplayLocation(address) {
            return this.$root.whitelabel.isUs() ? `${address.city} ${address.postal_code}` : `${address.postal_code} ${address.city}`
        },

        isAllowed() {
            if(this.$root.whitelabel.setting('show_cookie_consent')) {
                const cookieLocale = this.$getCookie("cookie_config")
                return cookieLocale.includes("Optional Functionalities")
            }
            return true
        }
    },
    computed: {
        pickupDeliveryOption() {
            return this.entry.delivery_option
        },
        returnDeliveryOption() {
            return this.entry.pick_up_option
        },
        pickupLocationPrice() {
            return this.pickupLocation ? this.getPrice(this.pickupLocation) : ''
        },
        returnLocationPrice() {
            return this.returnLocation ? this.getPrice(this.returnLocation) : ''
        },
        pickupLocationDistance() {
            return this.pickupLocation ? this.pickupLocation.distance : ''
        },
        returnLocationDistance() {
            return this.returnLocation ? this.returnLocation.distance : ''
        },
        pickupDisplayLocation() {
            return this.getDisplayLocation(this.entry.address)
        },
        returnDisplayLocation() {
            if (this.entry.first_return_location) {
                return this.getDisplayLocation(this.entry.first_return_location)
            }
            return false
        },
        formattedAddress() {
          return `${this.route} ${this.number}, ${this.city} ${this.country}`
        },
        route() {
            return this.address.route ?? ''
        },
        number() {
            return this.address.street_number ?? ''
        },
        city() {
            return `${this.zip} ${this.locality},`
        },
        locality() {
            return this.address.locality ?? ''
        },
        zip() {
            return this.address.postal_code ?? ''
        },
        country() {
            return this.address.country ? `, ${this.address.country}`: ''
        },
        getLocation() {
            return this.getDisplayLocation(this.address)
        },
        sameAddress() {
            if (this.pickupDisplayLocation === this.returnDisplayLocation) {
                return true
            } else {
                return false
            }
        },
        getLocationFromApi() {
            if (this.pickupDisplayLocation && this.returnDisplayLocation) {
                return 'both'
            } else {
                if (this.pickupDisplayLocation) {
                    return 'pick-up'
                } else {
                    return 'return'
                }
            }
        }
    }
}
</script>
